module.exports = __webpack_public_path__ + "media/images/gifts/music/sug_musica_3-88801e04235396df46138862f2ca8bc9.jpg";